export const getShippingSchema = () => ({
  title: "",
  description: "",
  type: "object",
  required: ["state_code", "recipient_name", "street", "city", "zip"],
  properties: {
    recipient_name: {
      type: "string",
      title: "Recipient name",
      readOnly: false,
      maxLength: 40,
      description: "",
    },
    street: {
      type: "string",
      title: "Billing street",
      readOnly: false,
      maxLength: 255,
      description: "",
    },
    city: {
      type: "string",
      title: "Billing city",
      readOnly: false,
      maxLength: 40,
      description: "",
    },
    state_code: {
      type: "string",
      title: "State",
      readOnly: false,
      maxLength: 80,
      enum: [
        "US",
        "AL",
        "AK",
        "AZ",
        "AR",
        "CA",
        "CO",
        "CT",
        "DE",
        "DC",
        "FL",
        "GA",
        "HI",
        "ID",
        "IL",
        "IN",
        "IA",
        "KS",
        "KY",
        "LA",
        "ME",
        "MD",
        "MA",
        "MI",
        "MN",
        "MS",
        "MO",
        "MT",
        "NE",
        "NV",
        "NH",
        "NJ",
        "NM",
        "NY",
        "NC",
        "ND",
        "OH",
        "OK",
        "OR",
        "PA",
        "RI",
        "SC",
        "SD",
        "TN",
        "TX",
        "UT",
        "VT",
        "VA",
        "VI",
        "WA",
        "WV",
        "WI",
        "WY",
      ],
      enumNames: [
        "Federal/countrywide",
        "Alabama",
        "Alaska",
        "Arizona",
        "Arkansas",
        "California",
        "Colorado",
        "Connecticut",
        "Delaware",
        "District Of Columbia",
        "Florida",
        "Georgia",
        "Hawaii",
        "Idaho",
        "Illinois",
        "Indiana",
        "Iowa",
        "Kansas",
        "Kentucky",
        "Louisiana",
        "Maine",
        "Maryland",
        "Massachusetts",
        "Michigan",
        "Minnesota",
        "Mississippi",
        "Missouri",
        "Montana",
        "Nebraska",
        "Nevada",
        "New Hampshire",
        "New Jersey",
        "New Mexico",
        "New York",
        "North Carolina",
        "North Dakota",
        "Ohio",
        "Oklahoma",
        "Oregon",
        "Pennsylvania",
        "Rhode Island",
        "South Carolina",
        "South Dakota",
        "Tennessee",
        "Texas",
        "Utah",
        "Vermont",
        "Virginia",
        "Virgin Islands",
        "Washington",
        "West Virginia",
        "Wisconsin",
        "Wyoming",
      ],
      description: "",
    },
    zip: {
      type: "string",
      title: "Billing zip code",
      readOnly: false,
      maxLength: 20,
      description: "",
    },
  },
});
